var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    'background-color': _vm.useBackgroundColor,
    'padding-top': `${_vm.paddingTop}px`,
    'padding-bottom': `${_vm.paddingBottom}px`
  })},[_c('div',{staticClass:"history-items",class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},_vm._l((_vm.blocks),function(block){return _c('bank-history-block',{key:block.id,attrs:{"fields":_vm.convertBlockFields(block)}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }